import api from '@/api-connect/index';

export default {
  checkIdentification: (rpps, adeli) => {
    const searchParams = new URLSearchParams();

    if (rpps) {
      searchParams.set('rpps', rpps);
    }

    if (adeli) {
      searchParams.set('adeli', adeli);
    }

    return api.get(`practitioners/check_fields`, { searchParams });
  },
};
